import { Helmet } from 'react-helmet-async'

import { useContext } from 'react'

import { faStore } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Columns,
} from '@domain-group/suit-theme'

import PageFilterModule from '@components/PageFilterModule'
import PageHeader from '@components/PageHeader'

import useAgencySelector from '@hooks/useAgencySelector'

import NotificationBannerLocation from '@components/NotificationBannerLocation'
import NotificationModuleLocation from '@components/NotificationModuleLocation'
import PageContext, { DefaultContext, PageContextPayload } from '@contexts/pageContext'

import SavedArtworkPages from '../SavedArtworkPages'
import SavedArtworks from '../SavedArtworks'

const buildPageFilterFields = () => {
  const style = {
    marginBottom: 16,
  }

  return [
    {
      component: 'DynamicInput',
      componentProps: {
        inputComponent: 'input',
        style,
      },
      key: 'string',
      label: 'Filter by Title or ID',
    },
    {
      component: 'EntitySelector',
      componentProps: {
        entityKey: 'users',
        entityTitleKey: 'full_name',
        label: 'Creator',
        style,
      },
      key: 'user_id',
    },
  ]
}

interface PageContentProps {
  pageFilters: {},
}

const PageContent = (props: PageContentProps) => {
  const { pageFilters } = props

  const { selectedAgencyId } = useAgencySelector()

  const pageContext = useContext<DefaultContext<PageContextPayload>>(PageContext)
  const {
    callbacks: {
      resetFilters,
      updateFilters,
    },
    defaultFilters,
  } = pageContext

  return (
    <>
      <Helmet>
        <title>Saved Artworks | Realhub Admin</title>
      </Helmet>

      <PageHeader
        activeTabBarItemKey="saved_artworks"
        nestedNavigation
        tabBarItems={[
          // @ts-expect-error TS2741
          {
            icon: faStore,
            key: 'saved_artworks',
            title: 'Saved Artworks',
          },
        ]}
        title="Saved Artworks"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }} flexDirection={['column', 'column', 'row']}>
          <Columns.Main>
            <NotificationBannerLocation locationKey="agency.agencyManager.savedArtworks.banner" />

            <SavedArtworks pageFilters={pageFilters} selectedAgencyId={selectedAgencyId} />

            {/*
             // @ts-expect-error TS2322 */}
            <SavedArtworkPages pageFilters={pageFilters} selectedAgencyId={selectedAgencyId} />
          </Columns.Main>

          <Columns.Sidebar>
            <NotificationModuleLocation locationKey="agency.agencyManager.savedArtworks.sidebar" />

            <PageFilterModule
              callbacks={{ resetFilters, updateFilters }}
              defaultFilters={defaultFilters}
              // @ts-expect-error TS2322
              filterFields={buildPageFilterFields()}
              pageFilters={pageFilters}
            />
          </Columns.Sidebar>
        </Columns>
      </Box>
    </>
  )
}

export default PageContent
